import { AwardLead, AwardLeadRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignAwardLeads: (
  fetchContext: FetchContext,
  awardId: number,
  awardLead: AwardLead,
  accessToken?: string,
) => Promise<AwardLeadRef> = (fetchContext, awardId, awardLead, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/leads`,
  {
    method: 'POST',
    body: JSON.stringify(awardLead),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<AwardLeadRef>(fetchContext.errorStore, response, 'assign award leads'));
